import moment from 'moment'
import { useMemo } from 'react'

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function useDateRangeOptions(rangeType: string, year: string, month: string) {
  const monthOptions = useMemo(() => {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth()
    if (year === currentYear.toString()) {
      return monthNames.slice(0, currentMonth + 1).map((it, idx) => ({
        label: it,
        value: String(idx + 1),
      }))
    }

    return monthNames.map((it, idx) => ({
      label: it,
      value: String(idx + 1),
    }))
  }, [year])

  const optionsYear = useMemo(() => {
    const currentYear = new Date().getFullYear()
    return Array.from(Array(currentYear - 2023 + 1), (_, x) => 2023 + x).map((it) => ({
      label: String(it),
      value: String(it),
    }))
  }, [])

  const maxDate = useMemo(() => moment(), [])

  return { monthOptions, optionsYear, maxDate }
}
